const SCREEN_WIDTH: number =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

export const PAGE_SIZE = SCREEN_WIDTH >= 1025 && SCREEN_WIDTH <= 1919 ? 24 : 30;
